import { getBanners } from '~/src/api/banners';
import { getProductsInfo } from '~/src/api/profile/getProductsInfo';
import { getABNVariant } from '~/src/helpers/abn-tests';
import { SHOWING_TARIFF_CARDS, LABEL_CARDS_NEW } from '~/src/helpers/city';
import { SET_BANNERS_FOR_MAIN_PAGE, SET_PRODUCTS_INFO_FOR_MAIN_PAGE, SET_NEW_CARDS_VARIANT } from '../actionTypes/main';
import { captureException } from '@sentry/node';

export const getBannersForMainPage = (domainCity, isAuth) => {
    return async dispatch => {
        await getBanners(domainCity, isAuth, 'main')
            .then(response => {
                return dispatch(setBannersForMainPage(response.data.items));
            })
            .catch(error => captureException(error));
    };
};

export const getProductsInfoForMainPage = (domain, accessToken) => {
    return async dispatch => {
        await getProductsInfo(domain, accessToken)
            .then(productsInfo => {
                return dispatch(setProductsInfoForMainPage(productsInfo.services));
            })
            .catch(error => captureException(error));
    };
};

export const getNewCardsVariant = (req, res) => {
    return async(dispatch, getState) => {
        const state = getState();
        const prevEnableNewCards = state?.main?.enableNewCards;
        const abnTests = state?.city?.currentCity?.abnTests;
        const abnVariant = req ? getABNVariant({ abnTests, testName: SHOWING_TARIFF_CARDS, req, res }) : null;
        const enableNewCards = prevEnableNewCards || abnVariant?.label === LABEL_CARDS_NEW;

        dispatch(setNewCardsVariant(enableNewCards));
    };
};

export const setBannersForMainPage = (bannerData) => ({
    type: SET_BANNERS_FOR_MAIN_PAGE,
    payload: bannerData
});

export const setProductsInfoForMainPage = (productsInfo) => ({
    type: SET_PRODUCTS_INFO_FOR_MAIN_PAGE,
    payload: productsInfo
});

export const setNewCardsVariant = (newCardsData) => ({
    type: SET_NEW_CARDS_VARIANT,
    payload: newCardsData
});
